import React from "react";

import PaidPill from "./PaidPill";
import UnpaidPill from "./UnpaidPill";

export default function PaymentPill({
  name,
  additionalNameID,
  unpaidSlotsCount,
  isItemType,
  amount,
  totalAmountPaid,
  date,
  status,
  markedPaidName,
  userName,
  payerName,
  signupItemID,
  style,
  parentComponent, // "HouseholdMember" | "AdditionalName" | "Respondent"
}) {
  /**
   * HOUSEHOLD MEMBER
   */
  if (parentComponent === "HouseholdMember") {
    if (
      (isItemType && unpaidSlotsCount > 0) ||
      (status !== "Paid" && status !== "MarkedAsPaid")
    )
      return (
        <UnpaidPill
          name={name}
          additionalNameID={additionalNameID}
          unpaidSlotsCount={unpaidSlotsCount}
          isItemType={isItemType}
          signupItemID={signupItemID}
          style={style}
        />
      );

    return (
      <PaidPill
        amount={amount}
        totalAmountPaid={totalAmountPaid}
        date={date}
        status={status}
        markedPaidName={markedPaidName}
        additionalNameID={additionalNameID}
        userName={userName}
        payerName={payerName}
        signupItemID={signupItemID}
        style={style}
      />
    );
  }

  /**
   * ADDITIONAL NAME
   */
  if (parentComponent === "AdditionalName") {
    if (status === "Paid" || status === "MarkedAsPaid")
      // additional name shouldn't have totalAmountPaid b/c that is for item-type signup respondents and additional names are displayed for item-type signups
      return (
        <PaidPill
          amount={amount}
          date={date}
          status={status}
          markedPaidName={markedPaidName}
          additionalNameID={additionalNameID}
          userName={userName}
          payerName={payerName}
          signupItemID={signupItemID}
          style={style}
        />
      );
    return (
      <UnpaidPill
        name={name}
        additionalNameID={additionalNameID}
        signupItemID={signupItemID}
        style={style}
      />
    );
  }

  /**
   * RESPONDENT
   */
  if (parentComponent === "Respondent") {
    if (
      (isItemType && unpaidSlotsCount > 0) ||
      (status !== "Paid" && status !== "MarkedAsPaid")
    ) {
      return (
        <UnpaidPill
          name={name}
          additionalNameID={additionalNameID}
          unpaidSlotsCount={unpaidSlotsCount}
          isItemType={isItemType}
          signupItemID={signupItemID}
          style={style}
        />
      );
    }
    return (
      <PaidPill
        amount={amount}
        totalAmountPaid={totalAmountPaid}
        date={date}
        status={status}
        markedPaidName={markedPaidName}
        additionalNameID={additionalNameID}
        userName={userName}
        payerName={payerName}
        signupItemID={signupItemID}
        style={style}
      />
    );
  }

  return null;
}
